import api from '../services/api/api';

export const setAccessToken = (token: string) => {
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
};
